<template>
  <div class="row">
    <div
      class="col-md-12"
    >
      <div class="row">
        <div class="col-md-12">
          Enter number of months you want to check the TA has not acknowledged Continuing Assessor Competence.
          <div style="float:right;">
            <v-button
              size="xl"
              color="secondary"
              :disabled="unusedTAUsers.rows.length <= 0 || processingReport"
              @click="exportReport($store.state.cacAcknowledgeTAReport.forMonths)"
            >
              <v-icon type="download" />
              Export Report
            </v-button>
          </div>
        </div>
        <div
          class="col-md-12"
          style="display:flex; height: 3rem"
        >
          <v-fieldset
            :id="'reportInput'"
            v-model="forMonths"
            type="number"
            class="col-md-3"
            style="margin-left: -5px; margin-right: 10px;"
            :placeholder="$store.state.cacAcknowledgeTAReport.forMonths?$store.state.cacAcknowledgeTAReport.forMonths:'Enter Months'"
            :is-required="true"
            @input="forMonths_change"
          />
          <div style="display: flex; flex-direction: column;">
            <div class="hand">
              <input
                id="CAC_ACKNOWLEDGED"
                name="CAC_ACKNOWLEDGED_option"
                class="following__control"
                value="CAC_ACKNOWLEDGED"
                type="radio"
                style="margin-right: 1em;"
                :checked="'CAC_ACKNOWLEDGED' == cacReportSelectedOption"
                @change="(e) => cacReport_optionChange(e)"
              >
              <label for="CAC_ACKNOWLEDGED">
                TA's Acknowledged.
              </label>
            </div>
            <div class="hand">
              <input
                id="CAC_NOT_ACKNOWLEDGED"
                name="CAC_NOT_ACKNOWLEDGED_option"
                class="following__control"
                value="CAC_NOT_ACKNOWLEDGED"
                type="radio"
                style="margin-right: 1em;"
                :checked="'CAC_NOT_ACKNOWLEDGED' == cacReportSelectedOption"
                @change="(e) => cacReport_optionChange(e)"
              >
              <label for="CAC_NOT_ACKNOWLEDGED">
                TA's Didn't Acknowledge.
              </label>
            </div>
          </div>
          &nbsp;&nbsp;&nbsp;
          <v-button
            size="xl"
            color="primary"
            :disabled="forMonths <= 0 || processingReport"
            @click="performRunReport"
          >
            <v-icon type="power" />
            Run Report
          </v-button>
        </div>
        <div
          v-if="unusedTAUsers.rows.length > 0"
          class="col-md-12"
          style="display: flex; justify-content: space-between;"
        >
          <strong>
            TA(S) {{ selectedReportOptionState === 'CAC_ACKNOWLEDGED'? 'Acknowledged': "Didn't Acknowledged" }} in last {{ $store.state.cacAcknowledgeTAReport.forMonths }} months.
          </strong>
          <v-button
            size="xl"
            color="primary"
            @click="sendNotification"
          >
            <v-icon type="notification" />
            Send Notification
          </v-button>
        </div>
        <div class="col-md-12">
          <v-table
            :table="unusedTAUsers"
            :show-row-count="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {buildBreadCrumb, columnSort, columnFilter} from "@/common/tableFunctions"
  import Table from "@/molecules/Table";
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";
  import Fieldset from "@/molecules/Fieldset";
  import {mapState} from "vuex";
  import {CAC_ACKNOWLEDGE_TA_REPORT} from "../../store/actions.type";
import constants from '../../common/constants';

  export default {
    name: "ReportsCacTA",
    components: {
      "v-table": Table,
      "v-button": Button,
      "v-icon": Icon,
      "v-fieldset": Fieldset
    },
    data: () => ({
      cacReportSelectedOption: 'CAC_ACKNOWLEDGED',
      forMonths: '',
      processingReport: false,
      searchKeyword: '',
      searchMode: false,
      unusedTAUsers: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sortFn: columnSort,
            thClass: 'sortable',
            link: true,
            filterOptions: {
              enabled: true,
              placeholder: 'User Name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Email',
            field: 'emailObj',
            sortFn: columnSort,
            thClass: 'sortable',
            link: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Email',
              filterFn: columnFilter
            },
          },
          {
            label: 'CAC Acknowledge Date',
            field: 'cacUpdated_at',
            sortFn: columnSort,
            thClass: 'sortable',
            // hidden: true
          },
        ],
        rows: [],
      },
    }),
    computed: {
      ...mapState({
        cacAcknowledgeTaReportUsers: state => state.cacAcknowledgeTAReport.cacAcknowledgeTaReportUsers,
        selectedReportOptionState: state => state.cacAcknowledgeTAReport.selectedReportOption
      })
    },
    mounted() {
      this.updateBreadCrumb();
      this.getUsers();
      this.cacReportSelectedOption = this.selectedReportOptionState;
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Reports'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getUsers: function () {
        // this.showHideSelectedColumns();
        this.unusedTAUsers.rows = this.cacAcknowledgeTaReportUsers;
      },
      exportReport: function(months) {
        const cacUserOptions = constants.cacUserOptions;
        let csv = 'First Name, Last Name, Email, Phone, Address, Suburb, State, Postcode, Country, Last Used At, Profile Reviewed At, CAC Acknowledge Date';
        for(const ele of cacUserOptions) {
          csv += ','+ele.id+' '+ele.title.replace(/,/gm,' ');
        }
        csv += "\n";

        this.unusedTAUsers.rows.forEach((row) => {
                csv += row.first_name+','+row.last_name+','+row.email+','+row.mobile_number+','+(''+row.address).replace(/,/gm,' ')+','+row.suburb+','+row.state+','+row.postcode+','+row.country+','+row.last_used.value+','+row.reviewed_at.value+','+row.cacUpdated_at.value;
                for(const ele of cacUserOptions) {
                  let res = false;
                  if(row.user_info.cac_options) {
                    const arr = row.user_info.cac_options.filter(e => e.id == ele.id);
                    if(arr.length > 0) {
                      res = true
                    }
                    if(ele.id == 15 && res) {
                      res = arr[0].associatedText.replace(/,/gm,' ').replace(/\n/gm,' ');
                    }
                  }
                  csv += ','+res;
                }
                csv += "\n";
        });

        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = `Acknowledge_TAs_${months}_Months.csv`;
        anchor.click();
      },
      performRunReport: function() {
        if(this.forMonths <= 0) {
          return;
        }
        this.processingReport = true;
        this.$store.dispatch(CAC_ACKNOWLEDGE_TA_REPORT, {forMonths: this.forMonths, selectedReportOption: this.cacReportSelectedOption}).then((data) => {
          this.getUsers();
          this.processingReport = false;
        });
      },
      forMonths_change: function() {
        if(this.forMonths > 0) {
          this.processingReport = false;
          return;
        }
        this.processingReport = true;
      },
      sendNotification: function() {
        this.$router.push('/admin/notifications');
      },
      // below are CAC methods.
      cacReport_optionChange(e) {
        this.cacReportSelectedOption = null;
        if(e.target.checked) {
          this.cacReportSelectedOption =  e.target.value;
        }
      },
    }
  }
</script>
<style lang="scss">
  @import "../../styles/shared/shared";
  .hand {
    label {
      cursor: pointer;
    }
    input {
      cursor: pointer;
    }
  }
</style>
